<div class="container">
  <div class="card offset xp">

    <!-- Heading -->
    <h1 class="mb-0"
      id="claim-list-heading">Create WC Posting Notice Request</h1>

    <!-- Link to Service Requests Page -->
    <div class="border-bottom border-top py-2 mt-3">
      <a routerLink="/program/service-requests">
        <span class="fa fa-chevron-left"></span>
        {{ serviceRequestLabel.ADD_NEW_POLICY_REQ_LINK }}</a>
    </div>

    <!-- Verify Contact Information -->
    <div class="bg-secondary bg-opacity-10 my-4">
      <div class="row px-3">
        <div class="col-auto mx-3 mt-3 mb-4">
          <h3 class="mb-0">{{ serviceRequestLabel.VERIFY_CONTACT_INFO }}</h3>
        </div>
      </div>

      <div class="row px-4">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.INSURED_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="insuredNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-name-input"></lib-input></span>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.MAILING_RECIPIENT }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="recipientMailInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.FEIN_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <div class="col-md-8 ps-0"
            style="width:209.77px;padding-right:0px;">
            <lib-input [field]="feinInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-fein-input"></lib-input>
          </div>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.COMPANY_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="companyNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-company-name-input"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.CLAIM_REP_NUMBER_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1 pt-2">
          <div class="col-md-8 ps-1 form-group lib-input">
            <input type="text"
              class="form-control"
              [formControl]="addNewPolicyServiceRequestFormGroup.get('claimRepNumInput')"
              maxlength="14"
              (input)="formatPhoneNumber($event)"
              (blur)="validatePhoneNumberOnBlur($event, 'claimRepNumInput')">
          </div>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.ADDRESS_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="addressLine1InputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-address-name-input"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.DATE_NEEDED_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1 pt-2">
          <div class="col-md-8 ps-1">
            <app-treo-datepicker #dateNeededPicker
              [field]="dateNeededDatePickerConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id='add-New-Policy-request-details-Datepicker'
              (dateBlur)="dateChange($event)"></app-treo-datepicker>
               <div *ngIf="dateNeedErr">
              <div class="text-danger add-second-alert-padding"
                style="color:#b83b2f;margin-top:0px;"><span class="fa fa-exclamation-circle"
                  style="color:#b83b2f;"></span> Cannot enter a date prior to current date.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2 pt-2">
          <span></span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="addressLine2InputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.INSURED_ADDRESS_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="insuredAddressLine1InputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-address-line1-input"></lib-input></span>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.CITY_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="cityNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-city-name-input"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2">
          <span></span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="insuredAddressLine2InputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-address-line2-input"></lib-input></span>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.STATE_LABEL }}</span>
        </div>
        <div class="col-md-4 ps-4  pb-1">
          <span>
            <lib-select [field]="addNewPolicyStateConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-State-select"></lib-select>
            <div *ngIf="!isStateSelectionValid">
              <div class="text-danger add-second-alert-padding"
                style="color:#b83b2f;margin-top:-14px;"><span class="fa fa-exclamation-circle"
                  style="color:#b83b2f;"></span> Please select a State.
              </div>
            </div>
          </span>

        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.CITY_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="insuredCityNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-city-name-input"></lib-input></span>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.ZIP_CODE_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="zipcodeInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-zipCode-input"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.STATE_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <div class="col-md-8 ps-2">
            <lib-select [field]="addNewPolicyInsuredStateConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-State-select"></lib-select>
            <div *ngIf="!isInsuredStateSelectionValid">
              <div class="text-danger add-second-alert-padding"
                style="color:#b83b2f;margin-top:-14px;"><span class="fa fa-exclamation-circle"
                  style="color:#b83b2f;"></span> Please select a State.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.PHONE_LABEL }}</span>
        </div>
        <div class="col-md-2 pb-1 pt-2">
          <span class="form-group lib-input">
            <input type="text"
              class="form-control ml-5"
              [formControl]="addNewPolicyServiceRequestFormGroup.get('phoneNumberInput')"
              maxlength="14"
              (input)="formatPhoneNumber($event)"
              (blur)="validatePhoneNumberOnBlur($event, 'phoneNumberInput')">

          </span>
        </div>
        <div class="col-md-1 pt-1 ps-1 pb-1 fw-bold">
          <span>{{ serviceRequestLabel.EXTENTION_LABEL }}</span>
        </div>
        <div class="col-md-1 ps-1 pe-3 pb-1">
          <span><lib-input [field]="extensionInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-extension-input"></lib-input></span>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.ZIP_CODE_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="insuredZipcodeInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-insured-zipCode-input"></lib-input></span>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.PRODUCER_INFO}}</span>
        </div>
        <div class="col-md-4 pb-1 pt-2 ps-3">
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerName">{{serviceRequestVOResponse?.producerVO?.producerName}}</span>
          </div>
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerAddressLn1">{{serviceRequestVOResponse?.producerVO?.producerAddressLn1}}</span>
          </div>
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerAddressLn2">{{serviceRequestVOResponse?.producerVO?.producerAddressLn2}}</span>
          </div>
          <div>
            <span
              *ngIf="serviceRequestVOResponse?.producerVO?.producerCity">{{serviceRequestVOResponse?.producerVO?.producerCity}}</span>
            <span *ngIf="serviceRequestVOResponse?.producerVO?.producerStateDesc">,
              {{serviceRequestVOResponse?.producerVO?.producerStateDesc}}</span>
            <span *ngIf="serviceRequestVOResponse?.producerVO?.producerZipCode">,
              {{serviceRequestVOResponse?.producerVO?.producerZipCode}}</span>
          </div>
        </div>
      </div>

      <div class="row px-4 mb-0">
        <div class="col-md-2 ps-5 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.DATE_REQUESTED_LABEL }}</span>
        </div>
        <div class="col-md-4 pb-1 pt-2">
          <span>{{ formateDate(serviceRequestVOResponse?.requestDate, true) }}</span>
        </div>
        <div class="col-md-2 pt-2 fw-bold">
          <span>{{ serviceRequestLabel.TPA_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1">
          <span><lib-input [field]="tpaNameInputConfig"
              [group]="addNewPolicyServiceRequestFormGroup"
              id="add-New-Policy-tpa-name-input"></lib-input></span>
        </div>
      </div>

      <div class="row px-4">
        <div class="col-md-2 ps-5 pt-2 fw-bold pb-3">
          <span>{{ serviceRequestLabel.REQUESTED_BY_LABEL}}</span>
        </div>
        <div class="col-md-4 pb-1 pt-2">
          <span>{{ serviceRequestVOResponse?.requestedBy }}</span>
        </div>
        <div class="col-md-2 pt-2">
          <span></span>
        </div>
        <div class="col-md-4 pb-1">
          <span></span>
        </div>
      </div>

    </div>

    <!-- Request Details -->
    <div class="bg-secondary bg-opacity-10 my-4">
      <div class="row px-3">
        <div class="col-auto mx-3 mt-3">
          <h3 class="mb-0">{{ serviceRequestLabel.REQUEST_DETAILS }}</h3>
          <div *ngIf="!isRequestDetailsValid">
            <div class="text-danger add-second-alert-padding"
              style="color:#b83b2f"><span class="fa fa-exclamation-circle"
                style="color:#b83b2f;"></span> You must enter a number of paper or email copies for a state, enter
              comments, or attach a file to submit the request.
            </div>
          </div>
        </div>
      </div>
      <div>

      </div>

      <!-- tooltip -->
      <div class="d-flex justify-content-end">
        <lib-tooltip placement="top"
          [isCustomHTML]="true">
          <div class="tooltip-trigger">
            <a href="javascript:void(0)">{{postingNoticeStateExcepLabel}}<span
                class="fa fa-external-link ps-1"></span></a>
          </div>
          <div class="tooltip-content-heading-text border-bottom mb-0"><span
              class="h5">{{postingNoticeStateExcepLabel}}</span>
          </div>
          <div class="tooltip-content-body-text">
            <div *ngFor="let exceptionItem of serviceRequestVOResponse?.requestExceptionVO">
              <div class="h5 small">{{exceptionItem.exceptionTitle}}</div>
              <div class="small">{{exceptionItem.exceptionDescription}}</div>
            </div>
          </div>
        </lib-tooltip>
      </div>


      <div class="row px-4 ps-5">

        <div class="mt-4 mb-4">
          <ag-grid-angular style="width: 100%; height: 100%;"
            [rowData]="reqDetailsTableData"
            [columnDefs]="requestDetailsColumnDefs"
            [defaultColDef]="defaultColDef"
            [enableCellTextSelection]="true"
            [suppressRowClickSelection]="true"
            [suppressCellFocus]="true"
            [pagination]="totalRows > 10"
            class="ag-theme-quartz"
            overlayNoRowsTemplate="<span></span>"
            (gridReady)="onGridReadyReqDetails($event)"
            [paginationPageSize]="paginationPageSizeReqDetails"
            [paginationPageSizeSelector]="paginationPageSizeSelectorReqDetails"></ag-grid-angular>
        </div>
        <div class="margin">
          <div class="text-center font-weight-bold"
            *ngIf="reqDetailsTableData.length===0">{{
            serviceRequestLabel.NO_RECORD_FOUND_TXT }}</div>
        </div>
        <hr>
        <div class="requestsContainer">
          <div class="requestTemplate">
            <div class="row">
              <div class="col-md-3 pe-0 pt-2 fw-bold">
                <span>{{serviceRequestLabel.TOTAL_NUMBER_REQUESTED}}</span>
              </div>
              <div class="col-md-1 ps-0 pe-0 pt-2 fw-bold">
                <span>{{serviceRequestLabel.TOTAL_PAPER_COUNT}}</span>
              </div>
              <div class="col-md-1 ps-0 pe-0">
                <span><lib-input [field]="totalPaperCountInputConfig"
                    [group]="addNewPolicyServiceRequestFormGroup"
                    id="add-New-Policy-total-paper-count-input"></lib-input></span>
              </div>
              <div class="col-md-1 pe-0 pt-2 fw-bold">
                <span>{{serviceRequestLabel.TOTAL_EMAIL_COUNT}}</span>
              </div>
              <div class="col-md-1 ps-0 pe-0">
                <span><lib-input [field]="totalEmailCountInputConfig"
                    [group]="addNewPolicyServiceRequestFormGroup"
                    id="add-New-Policy-total-email-count-input"></lib-input></span>
              </div>
              <div class="col-md-2 pe-0 pt-2 fw-bold">
                <span>{{serviceRequestLabel.POSTING_NOTICE_EMAIL_ADDRESS}}</span>
              </div>
              <div class="col-md-3 ps-0 pt-2">
                <span><lib-input [field]="postingNoticeEmailAddInputConfig"
                    [group]="addNewPolicyServiceRequestFormGroup"
                    id="add-New-Policy-posting-notice-email-address-input"></lib-input></span>
                <div *ngIf="!isPostingNoticeEmailAddressValid">
                  <div class="text-danger add-second-alert-padding"
                    style="color:#b83b2f;margin-top:-14px;"><span class="fa fa-exclamation-circle"
                      style="color:#b83b2f;"></span> Email format must be name&#64;domain.xyz
                  </div>
                </div>
                <div *ngIf="!isPostingNoticeEmailAddress">
                  <div class="text-danger add-second-alert-padding"
                    style="color:#b83b2f;margin-top:-14px;"><span class="fa fa-exclamation-circle"
                      style="color:#b83b2f;"></span> You must enter a Posting Notice Email Address to submit a request
                    for email copies of notices.
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="md-12 pb-2 fw-bold"><span>{{serviceRequestLabel.COMMENTS_LABEL}}</span></div>
              <div class="md-12">
                <lib-textarea [field]="commentsTextAreaFieldConfig"
                  [group]="addNewPolicyServiceRequestFormGroup"
                  id="comments-textarea"></lib-textarea>
                <div class="numericinput">
                  <div class="text-end">
                    <span>{{ 4000 - (addNewPolicyServiceRequestFormGroup.get('commentsTextAreaField')?.value?.length ||
                      0) }} characters left</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- Select Additional Recipients to Receive Status Updates (Optional) -->
      <div class="my-4">
        <div class="row px-0">
          <div class="col-md-12 mx-0 mt-3">
            <lib-accordion #accordion>
              <div libAccordionPanel
                [id]="'selectAdditionalRecipientsId'"
                customPanelClass="custom-panel-class"
                [customTitle]="selectAdditionalRecipientsTitle"
                [body]="selectAdditionalRecipientsBody"
                [expanded]="true"></div>
            </lib-accordion>
            <ng-template #selectAdditionalRecipientsBody>

              <div class="mt-4 mb-4">
                <div class="lmrm">

                  <ag-grid-angular style="width: 60%; height: 100%;"
                    [rowData]="additionalReceipentsTableData"
                    [columnDefs]="additionalRecipientsColumnDefs"
                    [defaultColDef]="defaultColDef"
                    [rowSelection]="'multiple'"
                    [rowMultiSelectWithClick]="true"
                    [enableCellTextSelection]="true"
                    [suppressRowClickSelection]="false"
                    [pagination]="false"
                    class="ag-theme-quartz"
                    overlayNoRowsTemplate="<span></span>"
                    (gridReady)="onGridReadyAddReceipents($event)"
                    [paginationPageSize]="paginationPageSizeAddReceipents"
                    [paginationPageSizeSelector]="paginationPageSizeSelectorAddReceipents"
                    (cellClicked)="onCellClickedAddRecp($event)"
                    (selectionChanged)="onSelectionChangedAddReceipents()"></ag-grid-angular>
                  <div style="width: 60%;"
                    class="text-center font-weight-bold"
                    *ngIf="additionalReceipentsTableData.length===0">{{
                    serviceRequestLabel.NO_RECORD_FOUND_TXT }}</div>
                </div>


              </div>


            </ng-template>

            <ng-template #selectAdditionalRecipientsTitle
              let-panelData="panelData">
              <div class="title-wrapper">
                <span class="icon icon-caret-down pull-left px-2 pt-1 expanded"></span>
                <div class="flex-col">
                  <span class="col h4">{{ accordianData[0].title }} </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Attach Files (optional) -->
      <div class="my-4">
        <div class="row px-0">
          <div class="col-md-12 mx-0 mt-3">
            <lib-accordion #accordion>
              <div libAccordionPanel
                [id]="'attachFilesId'"
                customPanelClass="custom-panel-class"
                [customTitle]="attachFilesTitle"
                [body]="attachFilesBody"
                [expanded]="true"></div>
            </lib-accordion>


            <ng-template #attachFilesBody>
              <div class="lmrm pt-3">
                <ng-container *ngFor="let file of filesArray; let i = index">
                  <div class="row pt-3">
                    <div class="col-md-8">
                      <div class="custom-file-upload d-flex align-items-center">
                        <input type="text"
                          class="form-control bg-white"
                          [value]="file.name"
                          placeholder="No file selected"
                          readonly />
                        <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
                          type="button"
                          class="btn-secondary btn-sm file-upload-btn"
                          (click)="triggerFileInputClick(i)">Browse</button>
                        <input type="file"
                          #fileInputRefs
                          (change)="uploadFile($event, i)"
                          accept="*"
                          class="d-none" />
                      </div>
                    </div>
                    <div class="col-md-4"
                      *ngIf="filesArray.length < maxFiles">
                      <p class="pt-2">
                        <a (click)="addFile()"
                          role="button"
                          id="add-new-policy-add-file-link"
                          (keydown.enter)="addFile()"
                          class="text-decoration-none">
                          <span class="fa fa-plus"></span> {{ serviceRequestLabel.ADD_ANOTHER_FILE }}
                        </a>
                      </p>
                    </div>
                  </div>
                </ng-container>

              </div>
            </ng-template>
            <ng-template #attachFilesTitle
              let-panelData="panelData">
              <div class="title-wrapper"
                (click)="handleOnToggle($event)">
                <span class="icon icon-caret-down pull-left px-2 pt-1 expanded"></span>
                <div class="flex-col">
                  <span class="col h4">{{ accordianData[1].title }} </span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="border-top d-flex pt-3 mt-3">
        <div class="flex-grow-1">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn-secondary btn classic py-2"
            id="custom-alert-cancel-button"
            (click)="cancelForm()">Cancel</button>
        </div>
        <div class="ms-auto">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            class="btn-block btn-primary btn classic py-2"
            id="custom-alert-set-button"
            (click)="sendRequest()">Send Request</button>
        </div>
      </div>
      <div class="col-md-2">
      </div>
    </div>

    <div *ngIf="showCancelConfirmation"
      class="timeout-modal">
      <div class="modal-content">
        <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
          class="close-icon"
          (click)="confirmCancel(false)">
          <i class="fa fa-times"
            aria-label="Close"></i>
        </button>
        <h2>Confirmation</h2>
        <p>You have made changes to this page. Do you want to continue without saving your changes?</p>

        <div class="button-row">
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            (click)="confirmationcancel()"
            class="btn cancel-btn">Cancel</button>
          <button [attr.data-dl]="JSON.stringify({da_track: 'true'})"
            (click)=" proceedWithCancel()"
            class="btn btn-primary btn-sm">Continue</button>
        </div>
      </div>
    </div>